export default [
    {
        // [0]
        key: "travel",
        label: app.$i18n.t("Travel"),
        thClass:"text-center",
        visible: true
    },
    {
        // [1]
        key: "driver",
        label: app.$i18n.t("Driver"),
        visible: true
    },
    {
        // [2]
        key: "vehicle",
        label: app.$i18n.t("Vehicle"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true
    },
    {
        // [3]
        key: "travel_date",
        label: app.$i18n.t("Travel Date"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true
    },
    {
        // [4]
        key: "count_services",
        label: "O.S.",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true
    },
    {
        // [4]
        key: "count_documents",
        label: "O.D.",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true
    },
    {
        // [4]
        key: "status",
        label: app.$i18n.t("Status"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true
    },
    {
        // [5]
        key: "created_by",
        label: app.$i18n.t("Created By"),
        visible: true
    },
    {
        // [6]
        key: "actions",
        label: app.$i18n.t("Actions"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true
    }
]